import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=7bfacb0c&scoped=true&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySpinner.vue?vue&type=style&index=0&id=7bfacb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfacb0c",
  null
  
)

export default component.exports